import { useCallback, useEffect, useRef, useState } from 'react';
import { goToLocation } from 'assets/js/commonUtil';
import 'assets/css/main.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesDown, faAngleUp, faSortUp } from '@fortawesome/free-solid-svg-icons';

import DataBoard from 'components/board/dataBoard';

import { useSearchParams } from 'react-router-dom';
import ApplyList from 'components/board/applyList';

import 'swiper/css';
import 'swiper/css/navigation'; 

const Main = () => {

  const [searchParams] = useSearchParams();
  const str_utm_source = searchParams.get('utm_source');
  const str_utm_medium = searchParams.get('utm_medium');
  const str_utm_campaign = searchParams.get('utm_campaign');

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  console.log(`str_utm_source: ${str_utm_source}`);
  console.log(`str_utm_medium: ${str_utm_medium}`);
  console.log(`str_utm_campaign: ${str_utm_campaign}`);
  
  const ItemHandler = (e: React.MouseEvent<HTMLElement>) => { }
  
  const [pReffer, setReffer] = useState("");
  
  useEffect(() => {  
    let strReffer = document.referrer;
    strReffer = strReffer.replace("http://","").replace("https://","");
	  strReffer = strReffer.substring(0,strReffer.indexOf("/"));
   
    setReffer(strReffer);

    console.log(pReffer);
  }, []);

  return (
    <>
      <div className="common-wrapper">
        <div style={{lineHeight:0}}><img src="https://img.chunhomall.com/images/chunsimbon/MO_main_2508_002.jpg" alt="침향천진단 메인" style={{width:'100%'}} /></div>
        <div style={{lineHeight:0}}><img src="https://img.chunhomall.com/images/chunsimbon/MO_main_2508_003.jpg" alt="누적판매" style={{width:'100%'}} /></div>
        <div style={{lineHeight:0}}><img src="https://img.chunhomall.com/images/chunsimbon/MO_main_2508_004.jpg" alt="재구매율" style={{width:'100%'}} /></div>
        <div style={{lineHeight:0}}><img src="https://img.chunhomall.com/images/chunsimbon/MO_main_2508_005.jpg" alt="확인" style={{width:'100%'}} /></div>
        <div style={{lineHeight:0}}><img src="https://img.chunhomall.com/images/chunsimbon/MO_main_2508_006.jpg" alt="무료체험" style={{width:'100%'}} /></div>
        
        {/* 제품목록 */}
        <div className="apply-container">
          <div className='container'>
            <div className='common-title'>
              실시간 상담신청 현황
            </div>            
            <ApplyList />
          </div>
        </div>
        
       
        <div style={{ background: '#e4c49d' }}>
          <DataBoard
            strReffer={pReffer}
            str_utm_source={str_utm_source ?? ""}
            str_utm_medium={str_utm_medium ?? ""}
            str_utm_campaign={str_utm_campaign ?? ""}
          />
        </div>
      </div>
    </>
  );
}  
  
export default Main;
